const Column = ({ title, list }) => (
  <div>
    <p className="label">
      {title} · {list.length}
    </p>
    <div className="mt-4 space-y-5">
      {list.map((e) => (
        <div key={e.id} className="border border-[var(--line)] px-4 py-4">
          <p className="font-data text-[10px] uppercase tracking-[0.16em] text-zinc-500">
            T{e.high_tier}→T{e.low_tier} · {e.valence} · str {e.strength} · corrob{" "}
            {e.corroborations} · agree {e.valence_agreement}
          </p>
          <p className="mt-2 text-sm text-zinc-100">
            {e.high_name} ⟶ {e.low_name}
          </p>
          {e.thread && <p className="mt-2 text-xs leading-relaxed text-zinc-500">{e.thread}</p>}
          {e.trigger && (
            <p className="mt-2 text-xs text-zinc-600">
              trigger: {e.trigger} · response: {e.response_pattern}
            </p>
          )}
          {e.question_refs?.length > 0 && (
            <p className="mt-2 font-data text-[10px] text-zinc-700">
              {e.question_refs.join(" · ")}
            </p>
          )}
        </div>
      ))}
      {list.length === 0 && <p className="font-data text-[11px] text-zinc-600">None.</p>}
    </div>
  </div>
);

export const EdgesPanel = ({ m }) => (
  <div className="grid gap-10 lg:grid-cols-2" data-testid="admin-edges-panel">
    <Column title="Promoted influence nodes" list={m?.influence_nodes || []} />
    <Column title="Candidates (held)" list={m?.candidate_edges || []} />
  </div>
);

export default EdgesPanel;
